import { render } from "./AddClientAffecter.vue?vue&type=template&id=d643f4d6&ts=true"
import script from "./AddClientAffecter.vue?vue&type=script&lang=ts"
export * from "./AddClientAffecter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__